import { CSSProperties, PropsWithChildren } from "react";

import { cn } from "@bentolabs/kit/utils";

type Props = {
  style?: CSSProperties;
  className?: string;
};

export const Section = (props: PropsWithChildren<Props>) => {
  const { className, children, style } = props;
  return (
    <section
      style={style}
      className={cn(
        "relative container mx-auto flex w-full max-w-[1000px] flex-col gap-x-1.5 gap-y-4 px-4 py-10 md:flex-row md:py-36",
        className
      )}
    >
      {children}
    </section>
  );
};

type TitleProps = {
  className?: string;
};

const Title = (props: PropsWithChildren<TitleProps>) => {
  const { className, children } = props;
  return (
    <h2
      className={cn(
        "w-full items-center text-center text-[42px] leading-[105%] md:text-[64px]",
        className
      )}
    >
      {children}
    </h2>
  );
};

type DescriptionProps = {
  className?: string;
};

const Description = (props: PropsWithChildren<DescriptionProps>) => {
  const { className, children } = props;
  return (
    <p
      className={cn(
        "text-nobel mt-6 flex text-center text-lg leading-[150%]",
        className
      )}
    >
      {children}
    </p>
  );
};

Section.Title = Title;
Section.Description = Description;
